import React from 'react';
import PropTypes from 'prop-types';
import styles from '../header.scss';
import { t } from '../../../services/i18nService';
import navigationService from '../../../services/NavigationService';
import a11yIIBScreenReaderService from '../../../services/a11yIIBScreenReaderService';
import HeaderA11yService from '../../../services/HeaderA11yService';

const MessageButton = ({ isDisabled }) => {
    const isA11yIterationForIIBScreenReaderEnabled = a11yIIBScreenReaderService.isA11yIterationForIIBScreenReaderSupported();
    const messageButtonAriaLabel = HeaderA11yService.getMessageButtonAriaLabel(isA11yIterationForIIBScreenReaderEnabled);

    return (<button
        className={styles.messagesButton}
        onClick={navigationService.navigateToMessages}
        id="messagesMenuButton"
        disabled={isDisabled}
        {...(messageButtonAriaLabel && { 'aria-label': messageButtonAriaLabel })}
    >
        <span className={styles.icon}>
            <span className="sr-only">{t('header.messages')}</span>
            <i className="fa fa-bell-o fa-3" aria-hidden="true" />
        </span>
    </button>);
};

MessageButton.propTypes = {
    isDisabled: PropTypes.bool.isRequired,
};

export default MessageButton;
